import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconInternalTasklist(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M20.864 4.179a1 1 0 0 1 0 1.414l-8.511 8.51a.5.5 0 0 1-.707 0l-1.992-1.991a.998.998 0 0 1 1.41-1.414l.935.93 7.45-7.45a1 1 0 0 1 1.415 0Z"
        fill="currentColor"
      />
      <path
        d="M19.997 11.79c-.013-.504.294-.976.78-1.106l.025-.007c.572-.153 1.155.222 1.185.814a9.974 9.974 0 0 1-2.916 7.58c-3.905 3.906-10.237 3.906-14.142 0-3.905-3.905-3.905-10.236 0-14.142a9.975 9.975 0 0 1 7.58-2.916c.592.03.967.614.814 1.186l-.006.024c-.13.487-.603.793-1.107.78a8 8 0 1 0 7.787 7.787Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
